import { render, staticRenderFns } from "./TranslationsGroupTable.vue?vue&type=template&id=894a4726"
import script from "./TranslationsGroupTable.js?vue&type=script&lang=js&external"
export * from "./TranslationsGroupTable.js?vue&type=script&lang=js&external"
import style0 from "./TranslationsGroupTable.vue?vue&type=style&index=0&id=894a4726&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports